import React, { useState } from 'react';
import { BalatraGuide } from './pages/BalatraGuide';
import { GlossaryPage } from './pages/GlossaryPage';
type Page = 'guide' | 'glossary';
export function App() {
  const [page, setPage] = useState<Page>('guide');
  return <div style={{
    minHeight: '100vh',
    background: 'var(--bg-deep)'
  }} data-id="element-0">
      {/* Top-level page switcher */}
      <div style={{
      position: 'fixed',
      bottom: '1.5rem',
      right: '1.5rem',
      zIndex: 100,
      display: 'flex',
      gap: '0.5rem',
      background: 'rgba(13,6,24,0.95)',
      backdropFilter: 'blur(12px)',
      border: '1px solid rgba(255,215,0,0.25)',
      borderRadius: '12px',
      padding: '0.4rem',
      boxShadow: '0 4px 24px rgba(0,0,0,0.6), 0 0 20px rgba(255,215,0,0.05)'
    }} data-id="element-1">
        <button onClick={() => setPage('guide')} style={{
        padding: '0.5rem 0.9rem',
        borderRadius: '8px',
        fontSize: '0.75rem',
        fontFamily: 'Cinzel, serif',
        fontWeight: 700,
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        background: page === 'guide' ? 'rgba(255,215,0,0.15)' : 'transparent',
        border: page === 'guide' ? '1px solid rgba(255,215,0,0.5)' : '1px solid transparent',
        color: page === 'guide' ? '#FFD700' : '#7060a0',
        boxShadow: page === 'guide' ? '0 0 10px rgba(255,215,0,0.2)' : 'none'
      }} data-id="element-2">
          🃏 规则指南
        </button>
        <button onClick={() => setPage('glossary')} style={{
        padding: '0.5rem 0.9rem',
        borderRadius: '8px',
        fontSize: '0.75rem',
        fontFamily: 'Cinzel, serif',
        fontWeight: 700,
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        background: page === 'glossary' ? 'rgba(180,79,255,0.15)' : 'transparent',
        border: page === 'glossary' ? '1px solid rgba(180,79,255,0.5)' : '1px solid transparent',
        color: page === 'glossary' ? '#b44fff' : '#7060a0',
        boxShadow: page === 'glossary' ? '0 0 10px rgba(180,79,255,0.2)' : 'none'
      }} data-id="element-3">
          📖 词典
        </button>
      </div>

      {page === 'guide' ? <BalatraGuide data-id="element-4" /> : <GlossaryPage data-id="element-5" />}
    </div>;
}